import {
    formatDateForAPI,
    formatDateForLogOptions,
} from "@/lib/utils";

import { subDays } from "date-fns";

export const dateOptions = Array.from({ length: 8 }, (_, i) => {
    const date = subDays(new Date(), i);
    return {
        label: formatDateForLogOptions(date),
        offset: i,
        value: formatDateForAPI(date),
    };
});
